import authService from '../components/api-authorization/AuthorizeService'

export const solicitarTurno = async (boxAtencionID) => {
    const token = await authService.getAccessToken();
    const response = await fetch('api/TurnosPorBox/NuevoTurno/' + boxAtencionID, {
        method: "POST",
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    
    if (response.status === 401) {
        await authService.signIn();
    }

    const data = await response.json();
    return data;
}